import AuthButton from "../../components/auth/AuthButton";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import logo from "../../assets/TamilNadu_Logo.png";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useEffect, useState } from "react";

const Auth = () => {
  const [openModal, setOpenModal] = useState(false);
  useEffect(() => {
    setOpenModal(true);
  }, []);

  return (
    <Card className="w-[70%]">
      <CardContent>
        <div className="my-10">
          <h3 className="text-center font-semibold text-xl mb-3">
            Terms and Conditons*
          </h3>
          <ul className="list-disc mx-2">
            <li>
              The applicant must be a <b>weaver</b>
            </li>
            <li>
              All documents uploaded in the online application portal must be{" "}
              <b>clear and legible</b>
            </li>
            <li>
              Applications will be{" "}
              <b>scrutinized based on the prescribed priority factors.</b>
            </li>
            <li>
              The applicant must{" "}
              <b>not be a beneficiary of any other Government scheme. </b>
            </li>
          </ul>
        </div>
        <AuthButton />
      </CardContent>
      <Dialog open={openModal} onOpenChange={setOpenModal} className="w-full">
        <DialogContent className="w-[80%]">
          <DialogHeader>
            <DialogTitle>Terms and Conditions</DialogTitle>
          </DialogHeader>
          <div className="py-4">
            <ul className="list-disc mx-2">
              <li>
                The applicant must be a <b>weaver</b>
              </li>
              <li>
                All documents uploaded in the online application portal must be{" "}
                <b>clear and legible</b>
              </li>
              <li>
                Applications will be{" "}
                <b>scrutinized based on the prescribed priority factors.</b>
              </li>
              <li>
                The applicant must{" "}
                <b>not be a beneficiary of any other Government scheme. </b>
              </li>
            </ul>
          </div>
          <DialogFooter className="flex space-x-2">
            <Button
              type="button"
              onClick={() => {
                setOpenModal(false);
              }}
            >
              Agree and Proceed
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </Card>
  );
};

export default Auth;
